import axios from 'axios';
import SalarySimInputPostData from "../Model/SalarySimInputPostData";
import ResultData from "../Model/ResultData";

class DocgenModelContainer {
    model: DocgenModel = new DocgenModel();
    constructor (input: SalarySimInputPostData, result: ResultData, language: string) {
        this.model = new DocgenModel(input, result, language);
    };
};

class DocgenModel {
    input: SalarySimInputPostData = new SalarySimInputPostData();
    result: ResultData = new ResultData();
    language: string = "";
    constructor (input?: SalarySimInputPostData, result?: ResultData, language?: string) {
        if (input != undefined) this.input = input;
        if (result != undefined) this.result = result;
        if (language != undefined) this.language = language;
    };
};

const ServeDocument = (url: string, inputData: SalarySimInputPostData, resultData: ResultData, language:string) => {
    var docgenData = new DocgenModelContainer(inputData, resultData, language);

    return axios.post(url + "Docgen/GetDocument", docgenData, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        //responseType: "arraybuffer"
        // timeout: 0,
      })
};

export default ServeDocument;